const notebookLinks = {
  details: ({ namespace, arrayId }: { namespace: string; arrayId: string }) =>
    `/notebooks/details/${namespace}/${arrayId}`,

  overview: ({ namespace, arrayId }: { namespace: string; arrayId: string }) =>
    `/notebooks/details/${namespace}/${arrayId}/overview`,

  sharing: ({ namespace, arrayId }: { namespace: string; arrayId: string }) =>
    `/notebooks/details/${namespace}/${arrayId}/sharing`,

  settings: ({ namespace, arrayId }: { namespace: string; arrayId: string }) =>
    `/notebooks/details/${namespace}/${arrayId}/settings`,

  activity: ({ namespace, arrayId }: { namespace: string; arrayId: string }) =>
    `/notebooks/details/${namespace}/${arrayId}/activity`,

  preview: ({ namespace, arrayId }: { namespace: string; arrayId: string }) =>
    `/notebooks/details/${namespace}/${arrayId}/preview`,
};

export default notebookLinks;
